<div class="catalog-content">
    <app-catalouge-add-iap-content [iapData]="tempIapData" (refreshChange)="onRefresh($event)" [getSimilarAticleFlag]="getSimilarAticles"
     ></app-catalouge-add-iap-content>
    <app-catalouge-display-iap-content (editChange)="onTeamEdit($event)" (articleDeleteChange)="onArticleDelete()" ></app-catalouge-display-iap-content>
  </div>
